import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../../carta/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'carta-edit-name',
  templateUrl: 'carta-edit-name.html',
})
export class CartaEditNamePage {

  carta_uid: any = '';
  carta_name: any = '';
  carta_name_ca: any = '';
  carta_name_en: any = '';
  carta_name_it: any = '';
  carta_name_fr: any = '';
  carta_name_de: any = '';
  carta_subtitle: any = '';

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    private toastCtrl: ToastController,
    public cartaServices: CartaServices,
    public navParams: NavParams) {

    this.carta_uid = this.navParams.get('carta_uid');
    this.carta_name = this.navParams.get('carta_name');
    this.carta_name_ca = this.navParams.get('carta_name_ca');
    this.carta_name_en = this.navParams.get('carta_name_en');
    this.carta_name_it = this.navParams.get('carta_name_it');
    this.carta_name_fr = this.navParams.get('carta_name_fr');
    this.carta_name_de = this.navParams.get('carta_name_de');
    this.carta_subtitle = this.navParams.get('carta_subtitle');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  async updateCartaName() {
    //comprobar no buits
    if (this.carta_name != '' || this.carta_name_ca != '' || this.carta_name_en != '' || this.carta_name_it != '' || this.carta_name_fr != '' || this.carta_name_de != '') {
      await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
        'name': this.carta_name,
        'name_ca': this.carta_name_ca,
        'name_en': this.carta_name_en,
        'name_it': this.carta_name_it,
        'name_fr': this.carta_name_fr,
        'name_de': this.carta_name_de,
        'subtitle': this.carta_subtitle,
        'updated_at': new Date()
      }).then(doc => {
        //dismis
        this.close()
      });
    } else {
      //toast error
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/carta-edit-name/carta-edit-name.ts